@if (isVisible) {
  <div class="ui-alert" [class]="typeClass" [attr.role]="isUrgent ? 'alert' : 'status'"
    [attr.aria-live]="isUrgent ? 'assertive' : 'polite'">
    @if (title) {
      <div class="alert-header">
        <strong>{{ title }}</strong>
      </div>
    }
    <div class="alert-content">
      <ng-content></ng-content>
    </div>
    @if (closable) {
      <button
        type="button"
        class="alert-close"
        (click)="close()"
        aria-label="Chiudi avviso"
      >
        ✕
      </button>
    }
  </div>
}
